import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import EntityTable from "../../common/tables/EntityTable";
import { EntityFieldTypes } from "@emberly/zenith-client";
import ResponsivePage from "../../common/core/ResponsivePage";
import config from "../../../config";

export default function WarehouseRegister() {
  const { t } = useTranslation();

  const columns = useMemo(() => {
    return [
      {
        field: "name",
        headerName: t("warehouseRegister:fieldName"),
        flex: 1,
        minWidth: 120,
      },
      {
        field: "address",
        headerName: t("entity:location:address"),
        flex: 1,
        valueGetter: (_, row) => row.location?.address || "-",
        minWidth: 120,
      },
    ]
  }, [t]);

  const fields = useMemo(() => [
    { name: t("warehouseRegister:fieldName"), path: "name", type: EntityFieldTypes.String, required: true },
    { name: t("entity:location:address"), path: "location", type: EntityFieldTypes.Location },
  ], [t])

  return (
    <ResponsivePage
      title={t("warehouseRegister:title")}
      maxWidth={config.pageSize.medium}
    >
      <EntityTable
        tableId="warehouses"
        type="Warehouse"
        columns={columns}
        fields={fields}
        createTitle={t("warehouseRegister:create")}
        editTitle={t("warehouseRegister:edit")}
        emptyStateTitle={t("warehouseRegister:emptyStateTitle")}
        emptyStateDescription={t("warehouseRegister:emptyStateDescription")}
        createButton
      />
    </ResponsivePage>
  );
}